/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum HarassmentCategory {
    SEXUAL = 'Sexual',
    PHYSICAL = 'Physical',
}
